import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import ReportsMetrics from "../components/reports/metrics/ReportsMetrics";
import Filters from "../components/filters/Filters";
import ReportDetails from "../components/reports/list_reports/ReportDetails";
import { BarChart3, FileText, ArrowLeft } from "lucide-react";

const VasPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const mode = searchParams.get("mode");
  const isReportMode = mode === "report";

  const handleShowReportTable = () => {
    setSearchParams({ mode: "report" });
  };

  const handleBackToMetrics = () => {
    setSearchParams({});
  };

  return (
    <section className="flex flex-col gap-8 p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="bg-white rounded-lg shadow-sm p-6 border">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            {isReportMode ? (
              <>
                <FileText className="w-6 h-6 text-blue-600" />
                <h1 className="text-2xl font-bold text-gray-900">
                  Report Details
                </h1>
              </>
            ) : (
              <>
                <BarChart3 className="w-6 h-6 text-blue-600" />
                <h1 className="text-2xl font-bold text-gray-900">
                  VAS Metrics
                </h1>
              </>
            )}
          </div>

          {isReportMode && (
            <button
              onClick={handleBackToMetrics}
              className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Back to Metrics
            </button>
          )}
        </div>
      </div>

      {/* Metrics View - Show when mode is NOT report */}
      {!isReportMode && (
        <>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 border-b border-gray-200"></div>
            <div className="p-6">
              <Filters filterType="basic" />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">
                Metrics Overview
              </h2>
            </div>
            <div className="p-6">
              <ReportsMetrics />
            </div>
          </div>

          {/* Action Button */}
          <div className="flex justify-center">
            <button
              onClick={handleShowReportTable}
              className="flex items-center gap-3 px-8 py-4 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md hover:shadow-lg transition-all duration-200 transform hover:scale-105"
            >
              <FileText className="w-5 h-5" />
              View Detailed Report Table
            </button>
          </div>
        </>
      )}

      {/* Report View - Show when mode is report */}
      {isReportMode && (
        <>
          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 border-b border-gray-200"></div>
            <div className="p-6">
              <Filters filterType="all" />
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm border">
            <div className="p-4 border-b border-gray-200">
              <h2 className="text-lg font-semibold text-gray-900">
                Report Details
              </h2>
            </div>
            <div className="p-6">
              <ReportDetails />
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default VasPage;
